var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar vh-100 h-100",class:{
    'sidebar--open': _vm.sidebarOpen
  }},[_c('ToggleSidebar'),_c('div',{staticClass:"sidebar__content h-100"},[_c('div',{staticClass:"sidebar__elements h-100"},[_c('AppLogo'),_c('UserInfo'),_c('MainMenu')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }